/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import Rails from "rails-ujs";
Rails.start();

import "bootstrap/js/dist/util";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/toast";

import "javascripts/twitter_widget";
import "javascripts/webpage/sentry";
import "javascripts/webpage/lazyload";
import "javascripts/webpage/aos";
import "javascripts/webpage/autosize";
import "javascripts/webpage/common";
import "javascripts/webpage/onclick";
import "javascripts/webpage/bulk_clips";
import "javascripts/webpage/inquiries";
import "javascripts/webpage/rich_content";
import "javascripts/webpage/specials";
import "javascripts/webpage/surveys";
import "javascripts/webpage/clipboard-copy";
import "javascripts/webpage/map-image";
import "javascripts/webpage/spot-map";
import "javascripts/webpage/clips";
import "javascripts/webpage/trip-lists";
import "javascripts/webpage/users";
import "javascripts/webpage/presses";
import "javascripts/webpage/pc/scroll-compare";
import "javascripts/webpage/pc/perfect-scrollbar";
import "javascripts/webpage/pc/spottable";
